import { MetaPixelAnalytics } from '@chew/common/services/analytics/meta-pixel';

import { EventProperties } from './event-properties';

export const metaPixelAnalytics = new MetaPixelAnalytics<EventProperties>();
